/**
 * Validates that an access key has a valid format.
 * Valid keys are non-empty alphanumeric strings (with _ and -) between 6-50 characters.
 * 
 * @param {any} key - The access key to validate
 * @returns {boolean} - True if the key is valid, false otherwise
 */
export function isValidAccessKey(key) {
  return typeof key === 'string' 
    && key.length >= 6 
    && key.length <= 50 
    && /^[a-zA-Z0-9_-]+$/.test(key);
}
